export default {
  getCntGridSample: state => state.cnt,
  getGridDataGridSample: state => state.gridData,
  getSearchParamGridSample: state => state.searchParam,
  getProjectListGridSample: state => state.projectList,
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridSample/gridSampleGetter.js